import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {fetchX} from '../../util/fetch';
import {rootApiUrl} from '../api/api-const';

function getHostName(): string {
    return typeof location !== 'undefined' ? location.hostname : '';
}

// The review-generator is a synthetic per-environment catalog, so its id differs by backend:
// prod (go.rocketdata.io) = 472, preprod (*.space) = 208. On localhost the app is served
// locally but talks to a real backend via the dev proxy (API_URL), so fall back to API_URL.
function getReviewGeneratorCatalogId(): number {
    const host = getHostName();
    const target = host === 'localhost' ? process.env.API_URL || '' : host;

    return target.includes('.space') ? 208 : 472;
}

export const REVIEW_GENERATOR_CATALOG_ID = getReviewGeneratorCatalogId();

export type ReviewCatalogType = {
    can_abuse_review: boolean;
    icon: string;
    id: number;
    logo: string;
    name: string;
    slug: null;
    is_external_reviews: boolean;
    is_medicine: boolean;
    is_store: boolean;
    gpt_suggest_supported: boolean;
};

const reviewsCatalogListUrl = `${rootApiUrl}/v4/reviews/catalogs/`;

function fetchReviewsCatalogList(): Promise<Array<ReviewCatalogType>> {
    return fetchX<Array<ReviewCatalogType>>(reviewsCatalogListUrl);
}

export function useReviewsCatalogList(): UseQueryResult<Array<ReviewCatalogType>> {
    return useQuery([reviewsCatalogListUrl], fetchReviewsCatalogList, {
        refetchOnWindowFocus: false,
    });
}
